import { useEffect, useState } from "react";
import { fetchCarePlans } from "./service";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import { getDecodedToken } from "../../utils/localStorage";
import { Button, Spin } from "antd";
import ProgressIndicator from "../../commonComponents/ProgressIndicator";
import { useLocation, useNavigate } from "react-router-dom";

const SelectCareProgram = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { patientCondition } = state;
  const tokenData: any = getDecodedToken();
  const { doctorId = "" } = tokenData?.user?.myT || {};
  const [plans, setPlans]: any = useState([]);
  const [carePlanLoader, setCarePlanLoader] = useState(false);

  useEffect(() => {
    if (patientCondition) {
      getCarePlans();
    }
  }, []);

  const getCarePlans = async () => {
    setCarePlanLoader(true);
    const res: any = await fetchCarePlans({
      medicalConditionGroupId: patientCondition?.medical_condition_group_id,
      doctorId,
    });
    setCarePlanLoader(false);
    setPlans(res?.data);
  };

  const handleCareProgramClick = (program: any) => {
    navigate("/patient-phone-number", {
      state: {
        ...state,
        patientCareProgram: {
          plan_master_id: program?.plan_master_id,
          plan_name: program?.plan_name,
        },
      },
    });
  };

  const backBtnHandler = () => {
    navigate("/patient-condition", {
      state: { ...state },
    });
  };

  return (
    <div className="p-6">
      <div className="w-full fixed top-0 left-0 z-10">
        <div className="p-6 bg-white mx-auto max-w-[1280px]">
          <div className="flex items-start font-semibold gap-x-2 pb-5">
            <img
              height={22}
              width={22}
              src={arrowLeft}
              alt="arrow-left"
              onClick={backBtnHandler}
            />
            <span>Refer care plan</span>
          </div>
          <ProgressIndicator currentStep={2} totalSteps={4} />
        </div>
      </div>
      {carePlanLoader ? (
        <div className="absolute top-1/2 left-1/2">
          <Spin size="large" />
        </div>
      ) : (
        <div className="mt-24 flex flex-start flex-col items-start">
          {plans?.length > 0 ? (
            <div>
              <span className="font-semibold text-2xl">
                Select Care Program
              </span>
              {plans?.map((item: any, index: number) => (
                <div key={index} className="pt-5">
                  <img
                    src={item?.image_url}
                    alt="care-program"
                    onClick={() => handleCareProgramClick(item)}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div>
              <div className="w-full absolute top-[40%] left-0">
                <div className="mx-auto max-w-[1280px] w-full">
                  <p className="p-6">
                    It looks like there are no plans associated with the
                    selected indication. Please choose another indication.
                  </p>
                </div>
              </div>
              <div className="w-full fixed bottom-0 left-0">
                <div className="mx-auto max-w-[1280px] w-full">
                  <div className="p-6 pt-0">
                    <Button
                      type="primary"
                      className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
                      onClick={backBtnHandler}
                    >
                      Go Back
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectCareProgram;
